module.exports = __webpack_public_path__ + "img/qthyjjfa_banner_img.e5701061.png";